import styled from 'styled-components';

export const TypeOfDataIndustryDropdownStyle = {
  Container: styled.div``,
};
